// Persistenza sessione Orbit. Salva SOLO il token JWT e i dati pubblici dell'utente
// (mai la password). "Rimani connesso" => localStorage (persiste a PWA chiusa/riaperta).
// Altrimenti => sessionStorage (termina alla chiusura completa dell'app).
const T = "orbit_token";
const U = "orbit_user";
const R = "orbit_remember";

function isRemember() {
  return localStorage.getItem(R) === "1";
}

// Dove risiede attualmente il token (per preservare la posizione su refresh/switch-profile)
function currentPersist() {
  if (localStorage.getItem(T)) return true;
  if (sessionStorage.getItem(T)) return false;
  return isRemember();
}

export function saveSession(token, user, remember) {
  const persist = remember === undefined ? currentPersist() : !!remember;
  const target = persist ? localStorage : sessionStorage;
  const other = persist ? sessionStorage : localStorage;
  if (token != null) target.setItem(T, token);
  if (user != null) target.setItem(U, JSON.stringify(user));
  if (persist) localStorage.setItem(R, "1");
  else localStorage.removeItem(R);
  other.removeItem(T);
  other.removeItem(U);
}

export function getToken() {
  return localStorage.getItem(T) || sessionStorage.getItem(T);
}

export function getCachedUser() {
  try {
    const raw = localStorage.getItem(U) || sessionStorage.getItem(U);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function clearSession() {
  [localStorage, sessionStorage].forEach((s) => {
    s.removeItem(T);
    s.removeItem(U);
  });
  localStorage.removeItem(R);
}
